import { translateFr as tfr } from "@/i18n";
// Shared config for the "Plan de carrière" feature (mirrors backend career_plan.py)

export const GOAL_CATEGORIES = [
  { id: "performance", label: "Performance" },
  { id: "playing_time", label: tfr("Temps de jeu / activité") },
  { id: "physical", label: tfr("Développement physique") },
  { id: "technical", label: tfr("Développement technique") },
  { id: "contract", label: tfr("Contrat") },
  { id: "transfer", label: "Transfert / recrutement" },
  { id: "visibility", label: tfr("Visibilité") },
  { id: "admin", label: "Administratif" },
  { id: "health", label: tfr("Santé") },
  { id: "education", label: "Formation" },
  { id: "selection", label: tfr("Sélection nationale") },
  { id: "ranking", label: "Classement" },
  { id: "other", label: "Autre" },
];
export const GOAL_CATEGORY_LABELS = Object.fromEntries(GOAL_CATEGORIES.map((c) => [c.id, c.label]));

export const MILESTONE_STATUSES = [
  { id: "upcoming", label: tfr("À venir") },
  { id: "in_progress", label: tfr("En cours") },
  { id: "completed", label: "Atteint" },
  { id: "at_risk", label: tfr("À risque") },
  { id: "delayed", label: tfr("Retardé") },
];
export const MILESTONE_STATUS_META = {
  completed: { label: "Atteint", dot: "bg-success border-success", badge: "bg-success/15 text-success border-success/30" },
  in_progress: { label: tfr("En cours"), dot: "bg-info border-info", badge: "bg-info/15 text-info border-info/30" },
  upcoming: { label: tfr("À venir"), dot: "bg-muted border-border", badge: "bg-secondary text-muted-foreground border-border" },
  at_risk: { label: tfr("À risque"), dot: "bg-warning border-warning", badge: "bg-warning/15 text-warning border-warning/30" },
  delayed: { label: tfr("Retardé"), dot: "bg-danger border-danger", badge: "bg-danger/15 text-danger border-danger/30" },
};

export const SEVERITY_META = {
  critical: { label: "Critique", cls: "bg-danger/15 text-danger border-danger/40" },
  high: { label: tfr("Élevé"), cls: "bg-danger/10 text-danger border-danger/25" },
  medium: { label: "Moyen", cls: "bg-warning/15 text-warning border-warning/30" },
  low: { label: "Faible", cls: "bg-secondary text-muted-foreground border-border" },
};

export const OWNER_TYPES = [
  { id: "agent", label: "Agent" },
  { id: "athlete", label: tfr("Athlète") },
  { id: "staff", label: "Staff" },
];
export const OWNER_LABELS = Object.fromEntries(OWNER_TYPES.map((o) => [o.id, o.label]));

export const OPP_TYPES = [
  { id: "club_interest", label: tfr("Intérêt club") },
  { id: "market_window", label: tfr("Fenêtre de marché") },
  { id: "competition", label: tfr("Compétition") },
  { id: "visibility", label: tfr("Visibilité") },
  { id: "selection", label: tfr("Sélection") },
  { id: "sponsoring", label: "Sponsoring" },
  { id: "other", label: "Autre" },
];
export const OPP_TYPE_LABELS = Object.fromEntries(OPP_TYPES.map((t) => [t.id, t.label]));

export const HORIZONS = [12, 24, 36, 48, 60];

export function scoreColor(score) {
  if (score === null || score === undefined) return "text-muted-foreground";
  if (score >= 80) return "text-success";
  if (score >= 50) return "text-warning";
  return "text-danger";
}
export function scoreBarColor(score) {
  if (score === null || score === undefined) return "bg-muted";
  if (score >= 80) return "bg-success";
  if (score >= 50) return "bg-warning";
  return "bg-danger";
}
